import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '../Card/Card';
import CardHeader from '../Card/CardHeader';
import styles from './styles';

const useStyles = makeStyles(styles);

const CardTitle = (props) => {
  const { title, subTitle, component } = props;

  const classes = useStyles();

  return (
    <>
      <Card plain>
        <CardHeader color="customAuteco">
          <h4 className={classes.cardTitleWhite}>{title}</h4>
          {component || subTitle &&
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              {component &&
                <div style={{ paddingLeft: '10px' }}>
                  {' '}
                  {component}
                </div>
              }
              {subTitle && <p className={classes.cardCategoryWhite}>{subTitle}</p>}
            </div>
          }
        </CardHeader>
      </Card>
    </>
  );
};

export default CardTitle;
